module.exports = __webpack_public_path__ + "6c8a378bad90293ab83d12bead054913.png";